const NOTE_HTML_ALLOWED_ATTRIBUTES = {
  a: ['href', 'title'],
  img: ['alt', 'height', 'src', 'style', 'width'],
  mark: ['style'],
  span: ['style'],
  td: ['colspan', 'rowspan'],
  th: ['colspan', 'rowspan'],
} as const;

export default NOTE_HTML_ALLOWED_ATTRIBUTES;
